import React, { useState } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { kryzenstoreSchema } from "../../../Schemas/Kryzen Store/kryzen_store_schema";
import axios from "axios";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import SimpleButton from "../../../Components/layouts/simple_button";
import { FcPaid } from "react-icons/fc";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";

const ShopifyProductAdd = () => {
  const [hasVariants, setHasVariants] = useState(false);
  const [selectedCollections, setSelectedCollections] = useState([]);
  const [collections, setCollections] = useState([]);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    performRequest("GET", "/shpkOrder/get-collections")
      .then((res) => {
        if (res.status === 200) {
          setCollections(res.data.collections);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", "/shpkOrder/get-locations/")
      .then((res) => {
        if (res.status === 200) {
          setLocations(res.data.locations);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const toggleCollection = (id) => {
    if (selectedCollections.includes(id)) {
      setSelectedCollections(selectedCollections.filter((c) => c !== id));
    } else {
      setSelectedCollections([...selectedCollections, id]);
    }
  };

  // const handleSubmit = (values, { setSubmitting, resetForm }) => {
  //   // console.log('values', values);
  //   const formattedValues = {
  //     ...values,
  //     body_html: `<p>${values.body_html.replace(/\n/g, "<br/>")}</p>`,
  //     collections: selectedCollections,
  //   };

  //   if (!hasVariants) {
  //     formattedValues.variants = [
  //       {
  //         title: "Default Title",
  //         price: values.price,
  //         sku: values.sku,
  //         inventory_quantity: values.inventory_quantity,
  //         weight: values.weight,
  //         weight_unit: values.weight_unit,
  //         inventory_policy: values.inventory_policy,
  //         hsn: "",
  //         unit: "",
  //         size: "",
  //         imageInv: values.imageInv,
  //       },
  //     ];
  //   }

  //   performRequest("POST", "/shpkOrder/add-product/", {
  //     product: formattedValues,
  //   })
  //     .then((res) => {
  //       if (res.status === 200 && res.data.success) {
  //         Toast("success", "Product created successfully!");
  //         resetForm();
  //         setSelectedCollections([]);
  //       } else {
  //         Toast("error", "Error creating product!");
  //       }
  //     })
  //     .finally(() => setSubmitting(false));
  // };

  const fabricationProcessOptions = [
    { value: "repacking", label: "Repacking" },
    { value: "bending", label: "Bending" },
    { value: "punching", label: "punching" },
    { value: "holemaking", label: "Hole-Making" },
    { value: "cutting", label: "Cutting" },
    { value: "welding", label: "Welding" },
    { value: "painting", label: "Painting" },
    { value: "assembly", label: "Assembly" },
  ];
  const gstOptions = [
    { value: "0", label: "0" },
    { value: "5", label: "5" },
    { value: "12", label: "12" },
    { value: "18", label: "18" },
    { value: "28", label: "28" },
  ];

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    // 1️⃣ Format product values
    const formattedValues = {
      ...values,
      body_html: `<p>${values.body_html.replace(/\n/g, "<br/>")}</p>`,
      collections: selectedCollections,
    };

    if (!hasVariants) {
      formattedValues.variants = [
        {
          title: values.title,
          price: values.price,
          sku: values.sku,
          inventory_quantity: values.inventory_quantity,
          weight: values.weight,
          weight_unit: values.weight_unit,
          inventory_policy: values.inventory_policy,
          // hsn: values.hsn || "",
          // unit: values.unit || "",
          // size: values.size || "",
          // specificationsNew: values.specificationsNew || [],
          // locations: values.locations || [],
          // fabricationChargesMarkup: values.fabricationChargesMarkup || "3",
          // handlingCharges: values.handlingCharges || "2.5",
          // gst: "18",
          // optionalWarrantyCovergePerUnit: "1",
        },
      ];
    }

    const formData = new FormData();
    formData.append("product", JSON.stringify(formattedValues));
    if (values.imageInv) {
      formData.append("imageInv", values.imageInv); // append file
    }

    performRequest("POST", "/shpkOrder/add-product/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          Toast("success", "Product created successfully!");
          resetForm();
          setSelectedCollections([]);

          const fileInput = document.getElementById("imageInvInput");
          if (fileInput) fileInput.value = "";
        } else {
          Toast("error", "Error creating product!");
        }
      })
      .catch((err) => {
        console.error(
          "❌ Error uploading product:",
          err.response || err.message
        );
        Toast("error", "Server error while creating product!");
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <div className="container-xl py-4">
      <div className="page-header d-print-none">
        <div className="row g-2 align-items-center">
          <div className="col">
            <h2 className="page-title mb-1">
              <FcPaid />
              Add New Product
            </h2>
            <h4 className="text-muted">
              <StepRoutes />
            </h4>
          </div>
        </div>
      </div>
      <div className="card my-4 p-3">
        <div className="card-header mb-3">
          <h2>Add Product</h2>
        </div>
        <Formik
          initialValues={{
            title: "",
            body_html: "",
            price: 0,
            // sku: "",
            inventory_quantity: 0,
            weight: 0,
            weight_unit: "",
            inventory_policy: "deny",
            variants: [],
            images: [],
            metafields: {
              short_name: "",
              short_description: "",
            },
            track_inventory: false,
            hsn: "",
            unit: "nos",
            size: "",
            imageInv: "",
            specificationsNew: [],
            locations: [109594804500],
            fabricationChargesMarkup: "5",
            handlingCharges: "3",
            optionalWarrantyCovergePerUnit: "1",
            gst: "18",
            fabricationProcess: ["repacking"] || [],
          }}
          validationSchema={kryzenstoreSchema}
          onSubmit={handleSubmit}
        >
          {({ values, touched, setFieldValue, isSubmitting, errors }) => (
            <Form>
              {/* Title & Description */}
              <div className="mb-3 row">
                <label className="w-25 form-label col-3 required fs-3">
                  Product Name
                </label>

                <div className="w-100 col">
                  <Field name="title" className="form-control" />
                  {touched.title && errors.title && (
                    <p className="text-danger">{errors.title}</p>
                  )}
                </div>
              </div>
              <div className="mb-3 row">
                <label className="w-25 form-label col-3 required fs-3">
                  Product Description
                </label>
                <div className="w-100 col">
                  <Field
                    as="textarea"
                    name="body_html"
                    className="form-control"
                  />
                  {touched.body_html && errors.body_html && (
                    <p className="text-danger">{errors.body_html}</p>
                  )}
                </div>
              </div>
              {/* HSN Field */}
              <div className="mb-3 row">
                <label className="col-3 form-label fs-3">HSN</label>
                <div className="col">
                  <Field type="text" name="hsn" className="form-control" />
                  {touched.hsn && errors.hsn && (
                    <p className="text-danger">{errors.hsn}</p>
                  )}
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-3 form-label fs-3">
                  Inventory Product Image
                </label>
                <div className="col">
                  <input
                    id="imageInvInput"
                    type="file"
                    name="imageInv"
                    className="form-control"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      setFieldValue("imageInv", file); // store File object in Formik
                    }}
                  />
                  {touched.imageInv && errors.imageInv && (
                    <p className="text-danger">{errors.imageInv}</p>
                  )}
                </div>
              </div>

              {/* Unit Field */}
              <div className="mb-3 row">
                <label className="col-3 form-label required fs-3">Unit</label>
                <div className="col">
                  <Field as="select" name="unit" className="form-select">
                    <option value="">Select</option>
                    <option value="nos">Nos</option>
                    <option value="kg">Kg</option>
                    <option value="grams">Grams</option>
                    <option value="ltr">Litre</option>
                    <option value="ml">ML</option>
                    <option value="packs">Packs</option>
                    <option value="pair">Pair</option>
                    <option value="sqm">SqM</option>
                    <option value="sqft">SqFt</option>
                    <option value="mtr">Meters</option>
                    <option value="pcs">Pieces</option>
                  </Field>
                  {touched.unit && errors.unit && (
                    <p className="text-danger">{errors.unit}</p>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-3 form-label required fs-3 text-capitalize ">
                  {`Cost Per ${values.unit || "Unit"}`}
                </label>
                <div className="col">
                  <Field name="price" type="number" className="form-control" />
                  {touched.price && errors.price && (
                    <p className="text-danger">{errors.price}</p>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-3 form-label required fs-3">
                  In Stock Inventory
                </label>
                <div className="col">
                  <Field
                    name="inventory_quantity"
                    type="number"
                    className="form-control"
                  />
                  {touched.inventory_quantity && errors.inventory_quantity && (
                    <p className="text-danger">{errors.inventory_quantity}</p>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-3 form-label fs-3">Weight</label>
                <div className="col">
                  <div className="input-group">
                    <Field
                      name="weight"
                      type="number"
                      step="0.01"
                      className="form-control"
                      placeholder="Enter weight"
                    />
                    {touched.weight && errors.weight && (
                      <p className="text-danger">{errors.weight}</p>
                    )}
                    <Field
                      as="select"
                      name="weight_unit"
                      className="form-select"
                    >
                      <option value="kg">kg</option>
                      <option value="g">g</option>
                      <option value="oz">oz</option>
                      <option value="lb">lb</option>
                    </Field>
                    {touched.weight_unit && errors.weight_unit && (
                      <p className="text-danger">{errors.weight_unit}</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-3 form-label required fs-3">Size</label>
                <div className="col">
                  <div className="">
                    <Field as="select" name="size" className="form-select">
                      <option value="">Select</option>
                      <option value="Small">200g - 1kg (Small)</option>
                      <option value="Medium">1kg - 10kg (Medium)</option>
                      <option value="Large">10kg - 20kg (Large)</option>
                      <option value="Extra Large">
                        20kg - 50kg (Extra Large)
                      </option>
                      <option value="Double Extra Large">
                        50kg - 100kg (Double Extra Large)
                      </option>
                      <option value="Other">Other</option>
                    </Field>
                    {touched.size && errors.size && (
                      <p className="text-danger">{errors.size}</p>
                    )}
                  </div>
                </div>
              </div>

              {/* Track inventory */}
              <div className="mb-3 row">
                <label className="col-3 form-label required fs-3">
                  Track Inventory
                </label>
                <div className="w-100 col">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={values.track_inventory}
                    style={{ height: "25px", width: "25px" }}
                    onChange={(e) =>
                      setFieldValue("track_inventory", e.target.checked)
                    }
                  />
                  {touched.track_inventory && errors.track_inventory && (
                    <p className="text-danger">{errors.track_inventory}</p>
                  )}
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-3 form-label required fs-3">
                  Continue selling when out of stock
                </label>
                <div className="w-100 col">
                  <Field
                    type="checkbox"
                    name="inventory_policy"
                    className="form-check-input"
                    style={{ height: "25px", width: "25px" }}
                    checked={values.inventory_policy === "continue"}
                    onChange={(e) =>
                      setFieldValue(
                        "inventory_policy",
                        e.target.checked ? "continue" : "deny"
                      )
                    }
                  />
                  {touched.inventory_policy && errors.inventory_policy && (
                    <p className="text-danger">{errors.inventory_policy}</p>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <label className="col-3 form-label required fs-3">
                  Select Location
                </label>
                <div className="col">
                  {" "}
                  <div
                    className=" p-2 w-100 col d-flex flex-wrap gap-3"
                    // style={{ height: "200px", overflowY: "auto" }}
                  >
                    {locations.map((loc) => (
                      <div key={loc.id} className="form-check mb-2">
                        <input
                          type="radio"
                          className="form-check-input fs-4"
                          id={`loc-${loc.id}`}
                          name="location" // ✅ group radios
                          checked={values.locations[0] === loc.id}
                          onChange={() => setFieldValue("locations", [loc.id])} // ✅ store as array with one ID
                          style={{ height: "25px", width: "25px" }}
                        />

                        <label
                          className="form-check-label ms-2 fs-3"
                          htmlFor={`loc-${loc.id}`}
                        >
                          {loc.name}
                        </label>
                      </div>
                    ))}
                  </div>
                  {touched.locations && errors.locations && (
                    <p className="text-danger">{errors.locations}</p>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3 fs-3">
                  Fabrication Charges Markup Percentage
                </label>
                <div className="w-100 col">
                  <CustomInput
                    type="text"
                    name="fabricationChargesMarkup"
                    placeholder="default  is 3%"
                  />
                  {touched.fabricationChargesMarkup &&
                    errors.fabricationChargesMarkup && (
                      <p className="text-danger">
                        {errors.fabricationChargesMarkup}
                      </p>
                    )}
                </div>
              </div>
              <div className="mb-3 row">
                <label className="w-25 form-label col-3 fs-3">
                  Handling Charges Percentage
                </label>
                <div className="w-100 col">
                  <CustomInput
                    type="text"
                    name="handlingCharges"
                    placeholder="default is 2.5%"
                  />
                  {touched.handlingCharges && errors.handlingCharges && (
                    <p className="text-danger">{errors.handlingCharges}</p>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3 fs-3">
                  Optional Warranty Coverge Per Unit
                </label>
                <div className="w-100 col">
                  <CustomInput
                    type="text"
                    name="optionalWarrantyCovergePerUnit"
                    placeholder="default is 1"
                  />
                  {touched.optionalWarrantyCovergePerUnit &&
                    errors.optionalWarrantyCovergePerUnit && (
                      <p className="text-danger">
                        {errors.optionalWarrantyCovergePerUnit}
                      </p>
                    )}
                </div>
              </div>

              <div className="mb-3 row mt-3">
                <label className="w-25 form-label col-3 required fs-3">
                  GST Percentage
                </label>
                <div className="w-100 col d-flex flex-wrap">
                  {gstOptions.map((type) => {
                    const isChecked = values?.gst === type?.value;
                    return (
                      <div className="form-check me-3" key={type?.value}>
                        <input
                          type="radio"
                          className="form-check-input"
                          id={type.value}
                          name="gst"
                          value={type.value}
                          checked={isChecked}
                          onChange={() => {
                            setFieldValue("gst", type.value);
                          }}
                          style={{ height: "25px", width: "25px" }}
                          // onBlur={props.handleBlur}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={type?.value}
                        >
                          {type?.label}
                        </label>
                      </div>
                    );
                  })}

                  {touched.gst && errors.gst && (
                    <p className="text-danger w-100">{errors.gst}</p>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3 required fs-3">
                  Fabrication Process
                </label>
                <div className="w-100 col d-flex flex-wrap">
                  {fabricationProcessOptions.map((type) => {
                    // const isChecked =
                    //   props?.values?.fabricationProcess?.includes(
                    //     type?.value
                    //   );
                    const isChecked =
                      values?.fabricationProcess?.includes(type.value) ?? false;

                    return (
                      <div className="form-check me-3" key={type?.value}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={type?.value}
                          name="fabricationProcess"
                          checked={isChecked}
                          style={{ height: "25px", width: "25px" }}
                          onChange={(e) => {
                            const selected = [...values?.fabricationProcess];

                            if (e.target.checked) {
                              selected?.push(type?.value);
                            } else {
                              const index = selected.indexOf(type.value);
                              if (index > -1) selected.splice(index, 1);
                              // const specIndex = specs.findIndex(
                              //   (item) => item.type === type.value
                              // );
                              // if (specIndex > -1)
                              //   specs.splice(specIndex, 1);
                            }

                            setFieldValue("fabricationProcess", selected);
                            // props.setFieldValue(
                            //   "specificationsNew",
                            //   specs
                            // );
                          }}
                          // onBlur={props.handleBlur}
                        />
                        <label
                          className="form-check-label fs-3"
                          htmlFor={type?.value}
                        >
                          {type?.label}
                        </label>
                      </div>
                    );
                  })}

                  {touched.fabricationProcess && errors.fabricationProcess && (
                    <p className="text-danger w-100">
                      {errors.fabricationProcess}
                    </p>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <label className="w-25 form-label col-3 required fs-3">
                  Select Collections
                </label>

                <div
                  className="border rounded p-2 w-100 col"
                  style={{ height: "400px", overflowY: "auto" }}
                >
                  {collections.map((col) => (
                    <div key={col.id} className="form-check mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input fs-2"
                        id={`collection-${col.id}`}
                        value={col.id}
                        checked={selectedCollections.includes(col.id)}
                        // onChange={() => {
                        //   if (selectedCollections.includes(col.id)) {
                        //     setSelectedCollections(
                        //       selectedCollections.filter((c) => c !== col.id)
                        //     );
                        //   } else {
                        //     setSelectedCollections([
                        //       ...selectedCollections,
                        //       col.id,
                        //     ]);
                        //   }
                        // }}

                        onChange={() => {
                          let updatedSelected;

                          if (selectedCollections.includes(col.id)) {
                            // remove from selected
                            updatedSelected = selectedCollections.filter(
                              (c) => c !== col.id
                            );

                            // remove from Formik specs
                            const updatedSpecs =
                              values.specificationsNew.filter(
                                (s) => s.type !== col.title
                              );
                            setFieldValue("specificationsNew", updatedSpecs);
                          } else {
                            // add to selected
                            updatedSelected = [...selectedCollections, col.id];

                            // add to Formik specs
                            const newSpecs = [
                              ...values.specificationsNew,
                              {
                                type: col.title,
                                specification: "",
                              },
                            ];
                            setFieldValue("specificationsNew", newSpecs);
                          }

                          setSelectedCollections(updatedSelected);
                        }}
                      />

                      <label
                        className="form-check-label ms-2 fs-3"
                        htmlFor={`collection-${col.id}`}
                      >
                        <span className="fs-3">{col.title}</span>
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mb-3 row">
                {values.specificationsNew.map((item, index) => (
                  <div key={item.type} className="row mb-3">
                    <label className="col-3 form-label fs-3 text-capitalize">
                      {item.type} description
                    </label>
                    <div className="col-9">
                      <textarea
                        type="text"
                        className="form-control"
                        value={item.specification}
                        onChange={(e) => {
                          const updated = [...values.specificationsNew];
                          updated[index].specification = e.target.value;
                          setFieldValue("specificationsNew", updated);
                        }}
                      />
                      {touched.specificationsNew &&
                        errors.specificationsNew && (
                          <p className="text-danger w-100">
                            {errors.specificationsNew}
                          </p>
                        )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Images */}
              <div className="mb-3 row">
                <label className="w-25 form-label col-3 required fs-3">
                  Kryzen Store Images
                </label>
                <div className="w-100 col">
                  <input
                    type="file"
                    multiple
                    className="form-control"
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      const readers = files.map(
                        (file) =>
                          new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onloadend = () =>
                              resolve({ src: reader.result, alt: file.name });
                            reader.onerror = reject;
                            reader.readAsDataURL(file);
                          })
                      );
                      Promise.all(readers).then((imgs) =>
                        setFieldValue("images", [
                          ...(values.images || []),
                          ...imgs,
                        ])
                      );
                    }}
                  />
                  {touched.images && errors.images && (
                    <p className="text-danger w-100">{errors.images}</p>
                  )}
                </div>
                <div className="row mb-3">
                  <div className="col-3"></div>
                  <div className="w-100 col">
                    {" "}
                    <div className="d-flex flex-wrap gap-3 mt-2">
                      {values.images.map((img, idx) => (
                        <div key={idx} className="border p-1">
                          <img
                            src={img.src}
                            alt={img.alt}
                            style={{
                              width: 100,
                              height: 100,
                              objectFit: "cover",
                            }}
                          />
                          <br />
                          <button
                            type="button"
                            className="btn btn-sm btn-danger mt-1"
                            onClick={() => {
                              const updated = values.images.filter(
                                (_, i) => i !== idx
                              );
                              setFieldValue("images", updated);
                            }}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Variants toggle */}
              <div className="mb-3 row">
                <label className="w-25 form-label col-3  fs-3">
                  Has Multiple Variants
                </label>
                <div className="w-100 col">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    style={{ height: "25px", width: "25px" }}
                    checked={hasVariants}
                    onChange={(e) => setHasVariants(e.target.checked)}
                  />
                </div>
              </div>

              {hasVariants && (
                <FieldArray name="variants">
                  {({ remove, push }) => (
                    <div className="mb-3">
                      {values.variants.map((variant, index) => (
                        <div key={index} className="border rounded p-2 mb-2">
                          <div className="row g-3">
                            {/* Option 1 */}
                            <div className="col-md-2 mb-2">
                              <label className="mb-2">Option 1 Name</label>
                              <Field
                                name={`variants.${index}.option1Name`}
                                className="form-control"
                                placeholder="e.g. Size"
                              />

                              <label className="mb-2 mt-2">
                                Option 1 Value
                              </label>
                              <Field
                                name={`variants.${index}.option1`}
                                className="form-control"
                                placeholder="Small / Medium / Large"
                              />
                            </div>

                            {/* Option 2 */}
                            <div className="col-md-2">
                              <label className="mb-2">Option 2 Name</label>
                              <Field
                                name={`variants.${index}.option2Name`}
                                className="form-control"
                                placeholder="e.g. Color"
                              />
                              <label className="mb-2 mt-2">
                                Option 2 Value
                              </label>
                              <Field
                                name={`variants.${index}.option2`}
                                className="form-control"
                                placeholder="Red / Blue"
                              />
                            </div>

                            {/* Option 3 */}
                            <div className="col-md-2">
                              <label className="mb-2">Option 3 Name</label>
                              <Field
                                name={`variants.${index}.option3Name`}
                                className="form-control"
                                placeholder="e.g. Material"
                              />
                              <label className="mb-2 mt-2">
                                Option 3 Value
                              </label>
                              <Field
                                name={`variants.${index}.option3`}
                                className="form-control"
                                placeholder="Cotton / Polyester"
                              />
                            </div>

                            {/* Price */}
                            <div className="col-md-2">
                              <label className="mb-2">Price</label>
                              <Field
                                name={`variants.${index}.price`}
                                type="number"
                                className="form-control"
                              />
                            </div>

                            <div className="col-md-3">
                              <label className="mb-2">Weight</label>
                              <div className="input-group">
                                <Field
                                  name={`variants.${index}.weight`}
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  placeholder="Enter weight"
                                />
                                <Field
                                  as="select"
                                  name={`variants.${index}.weight_unit`}
                                  className="form-select"
                                >
                                  <option value="kg">kg</option>
                                  <option value="g">g</option>
                                  <option value="oz">oz</option>
                                  <option value="lb">lb</option>
                                </Field>
                              </div>
                            </div>
                          </div>

                          <div className="text-end mt-2">
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => remove(index)}
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}

                      <button
                        type="button"
                        className="btn btn-outline-success"
                        onClick={() =>
                          push({
                            option1Name: "",
                            option1: "",
                            option2Name: "",
                            option2: "",
                            option3Name: "",
                            option3: "",
                            price: 0,
                            sku: "",
                            inventory_quantity: 0,
                            weight: 0,
                            weight_unit: "",
                            inventory_policy: "deny",
                          })
                        }
                      >
                        + Add Variant
                      </button>
                    </div>
                  )}
                </FieldArray>
              )}

              <div className="card-footer">
                <div className="btn-list justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-primary mx-1 mt-2 "
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Saving…" : "Save Changes"}
                  </button>
                  <SimpleButton buttonText="Cancel" type="secondary" />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ShopifyProductAdd;
